"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bs58check_1 = __importDefault(require("bs58check"));
var errors_1 = require("@ledgerhq/errors");
var base_1 = __importDefault(require("./base"));
var bjs = __importStar(require("bitcoinjs-lib"));
var Zen = /** @class */ (function (_super) {
    __extends(Zen, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Zen(_a) {
        var network = _a.network;
        var _this = _super.call(this, { network: network }) || this;
        // refer to https://github.com/HorizenOfficial/zen/blob/master/src/chainparams.cpp for the blockchain params
        _this.network = network;
        _this.network.versions = {
            bip32: {
                public: 0x043587cf,
                private: 0x04358394
            },
            bip44: 121,
            private: 0x80,
            public: 0x2089,
            scripthash: 0x2096
        };
        _this.network.name = "Zencash";
        _this.network.unit = "ZEN";
        _this.network.messagePrefix = "Zencash Signed Message:\n";
        _this.network.wif = 0x80;
        _this.network.pubKeyHash = 0x2089;
        _this.network.scriptHash = 0x2096;
        _this.network.dustThreshold = 10000;
        _this.network.dustPolicy = "FIXED";
        _this.network.usesTimestampedTransaction = false;
        return _this;
    }
    Zen.prototype.getLegacyAddress = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var pk, _a, _b, payload;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = bjs.crypto).hash160;
                        return [4 /*yield*/, this.getPubkeyAt(xpub, account, index)];
                    case 1:
                        pk = _b.apply(_a, [_c.sent()]);
                        payload = Buffer.allocUnsafe(22);
                        payload.writeUInt16BE(this.network.pubKeyHash, 0);
                        pk.copy(payload, 2);
                        return [2 /*return*/, bs58check_1["default"].encode(payload)];
                }
            });
        });
    };
    Zen.prototype.customGetAddress = function (derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLegacyAddress(xpub, account, index)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Zen.prototype.toOutputScript = function (address) {
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        var outputScript;
        var version = Number("0x" + bs58check_1["default"].decode(address).slice(0, 2).toString("hex"));
        if (version === this.network.pubKeyHash) {
            //Pay-to-PubkeyHash
            outputScript = bjs.payments.p2pkh({
                hash: bs58check_1["default"].decode(address).slice(2)
            }).output;
        }
        else if (version === this.network.scriptHash) {
            //Pay-to-Script-Hash
            outputScript = bjs.payments.p2sh({
                hash: bs58check_1["default"].decode(address).slice(2)
            }).output;
        }
        else {
            throw new errors_1.InvalidAddress();
        }
        // refer to https://github.com/LedgerHQ/lib-ledger-core/blob/fc9d762b83fc2b269d072b662065747a64ab2816/core/src/wallet/bitcoin/scripts/BitcoinLikeScript.cpp#L139 and https://github.com/LedgerHQ/lib-ledger-core/blob/fc9d762b83fc2b269d072b662065747a64ab2816/core/src/wallet/bitcoin/networks.cpp#L39 for bip115 Script and its network parameters
        var bip115Script = Buffer.from("209ec9845acb02fab24e1c0368b3b517c1a4488fba97f0e3459ac053ea0100000003c01f02b4", "hex");
        return Buffer.concat([outputScript, bip115Script]);
    };
    Zen.prototype.validateAddress = function (address) {
        var res = bs58check_1["default"].decodeUnsafe(address);
        if (!res)
            return false;
        // refer to https://github.com/LedgerHQ/lib-ledger-core/blob/fc9d762b83fc2b269d072b662065747a64ab2816/core/src/wallet/bitcoin/networks.cpp#L142
        return (res &&
            res.length > 3 &&
            res[0] === 0x20 &&
            (res[1] === 0x89 || res[1] === 0x96));
    };
    return Zen;
}(base_1["default"]));
exports["default"] = Zen;
//# sourceMappingURL=zen.js.map